<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Rediger kontrakt</h4>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormSubmittable">
        <a href="javascript:;" @click="onKontraktCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" @click="onSaveButtonClick()" class="button primary">Lagre endringer</a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormProcessing">
        <a href="javascript:;" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary loading">Lagrer...<span class="loader-spinner"></span></a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormLoading">
        <a href="javascript:;" @click="onKontraktCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary" disabled>Lagre<span class="show-for-medium"> endringer</span></a>
      </div>
    </div>

    <KundeKontraktForm :kontrakt="kontrakt" :kunde="kunde" v-on:switchKontraktView="onKontraktCancel"/>
  </div>
</template>

<script>
import KundeKontraktForm from './KundeKontraktForm'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeKontraktEdit',
  components: {
    KundeKontraktForm
  },
  props: {
    kunde: {
      type: Object,
      required: true
    },
    kontrakt: {
      type: Object,
      required: true
    }
  },
  methods: {
    onKontraktCancel: function () {
      this.$emit('switchKontraktView', false)
    },
    onSaveButtonClick: function () {
      bus.$emit('kontrakt-form-submit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktEdit.vue